import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import MobileHeader from "./MobileHeader";
import Button from "@material-ui/core/Button";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";

function Header() {
  const [menu, setMenu] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const history = useHistory();

  const redirectHome = () => {
    history.push("/");
  };

  const handleMarketplace = () => {
    setAnchorEl(null);
    history.push("/");
  };

  return (
    <div className="header__bar">
      <div className="header__bar__in">
        <div>
          <h3 className="header__text__shrink">
            <i
              className="fa fa-bars menu__icon"
              style={{ marginRight: 20 }}
              onClick={() => setMenu(true)}
            ></i>
            {"  "}
            <strong
              style={{ cursor: "pointer" }}
              onClick={() => redirectHome()}
            >
              Marketplace
            </strong>{" "}
            <span style={{ fontSize: "14px" }}>by STPI</span>
          </h3>
        </div>
        <div className="list__header">
          <div style={{ float: "right" }}>
            <ul className="header__menu__top menu__1">
              <li>
                <a
                  rel="noreferrer noopener"
                  target="_blank"
                  href="https://finblue.stpi.in/incubator-program/about-finblue-incubator-program/#about-STPI"
                >
                  About Us
                </a>
              </li>
              <li>
                <a rel="noreferrer noopener">Contact Us</a>
              </li>
              <li>
                <a rel="noreferrer noopener">Privacy</a>
              </li>
              <li>
                <a rel="noreferrer noopener">Login</a>
              </li>
            </ul>
          </div>
          <div>
            <ul className="header__menu__top menu__2">
              <li onClick={() => redirectHome()}>
                <a rel="noreferrer noopener">Home</a>
              </li>
              <li>
                {" "}
                <a
                  rel="noreferrer noopener"
                  target="_blank"
                  href="https://finblue.stpi.in/incubator-program/apply-for-incubator-program/"
                >
                  Pitchfest
                </a>
              </li>
              <li>
                <a
                  rel="noreferrer noopener"
                  target="_blank"
                  href="https://finblue.stpi.in/incubator-program/fintech-incubator-program/"
                >
                  The Program
                </a>
              </li>
              <li>
                <Button
                  className="header__dropdown"
                  aria-controls="simple-menu"
                  aria-haspopup="true"
                  onClick={handleClick}
                >
                  Services
                </Button>
                <Menu
                  id="simple-menu"
                  anchorEl={anchorEl}
                  keepMounted
                  open={Boolean(anchorEl)}
                  onClose={handleClose}
                >
                  <MenuItem onClick={handleClose}>
                    <a
                      rel="noreferrer noopener"
                      target="_blank"
                      href="https://finblue.stpi.in/sandbox-api/"
                      style={{ textDecoration: "none", color: "black" }}
                    >
                      Sandbox API
                    </a>
                  </MenuItem>
                  <MenuItem
                    onClick={() => handleMarketplace()}
                    style={{ fontFamily: "inherit" }}
                  >
                    Marketplace
                  </MenuItem>
                </Menu>
              </li>
              <li>
                <a rel="noreferrer noopener">List Your Startup</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <MobileHeader setMenu={setMenu} menu={menu} />
    </div>
  );
}

export default Header;
